document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('delivery-popup');
  const receiverPopup = document.getElementById('receiver-popup');
  const giftPopup = document.getElementById('gift-popup');
  const giftQuickviewPopup = document.getElementById('gift-quickview-popup');
  const closeBtn = document.getElementById('close-delivery-popup');
  const closeReceiverPopupBtn = document.getElementById('close-receiver-popup');
  const closeGiftPopupBtn = document.getElementById('close-gift-popup');
  const closeGiftQuickviewBtn = document.getElementById('close-gift-quickview-popup');
  const confirmBtn = document.getElementById('confirm-delivery');
  const confirmRecieverBtn = document.getElementById('confirm-receiver');
  const confirmGiftsBtn = document.getElementById('confirm-gifts');
  const dateInput = document.getElementById('delivery-date');
  const timeSelect = document.getElementById('delivery-time');
  const hiddenDate = document.getElementById('hidden-delivery-date');
  const hiddenTime = document.getElementById('hidden-delivery-time');
  const infoMessageEl = document.getElementById('info-message');
  const giftInfoMessageEl = document.getElementById('gift-info-message');
  const checkboxFieldEls = document.querySelectorAll('[js-checkbox-field]');
  const receiverFields = document.querySelectorAll('[js-receiver-field]');
  const giftCheckboxes = document.querySelectorAll('[js-gift-checkbox]');
  const giftQuickviewTriggers = document.querySelectorAll('[data-gift-quickview-trigger]');

  // ✅ NUEVO: elementos internos del popup de vista rápida
  const quickviewImageEl = document.getElementById('gift-quickview-image');
  const quickviewPrevBtn = document.getElementById('gift-quickview-prev');
  const quickviewNextBtn = document.getElementById('gift-quickview-next');
  const quickviewDotsEl = document.getElementById('gift-quickview-dots');
  const quickviewTitleEl = document.getElementById('gift-quickview-title');
  const quickviewPriceEl = document.getElementById('gift-quickview-price');
  const quickviewDescriptionEl = document.getElementById('gift-quickview-description');
  const quickviewAddBtn = document.getElementById('gift-quickview-add');

  const productForm = document.querySelector('[js-product-form]');
  const addToCartBtn = document.querySelector('[js-atc-btn]');

  // ✅ Lista de domingos especiales permitidos
  const currentYear = new Date().getFullYear();
  const SPECIAL_SUNDAYS = new Set([
    `${currentYear}-03-21`,
    `${currentYear}-03-20`,
    `${currentYear}-09-21`,
    `${currentYear}-09-20`,
    `${currentYear}-05-10`,
    `${currentYear}-02-14`
  ]); 

  // ✅ Días bloqueados (25 dic y 1 ene)
  const BLOCKED_DATES = new Set([
    `${currentYear}-12-25`,
    `${currentYear + 1}-01-01`
  ]);

  // ✅✅ NUEVO: Configuración de horarios bloqueados por fecha
  // Formato: 'YYYY-MM-DD': [índices de horarios bloqueados]
  // Índice 1 = primer horario, 2 = segundo, 3 = tercero
  const BLOCKED_TIME_SLOTS = {
    '2026-02-14': [1],        // 14 feb: bloquea primer horario
    // Agrega más fechas según necesites:
    // '2025-03-08': [1, 2, 3],  // Bloquea todos los horarios
    // '2025-05-10': [2],        // Bloquea solo segundo horario
  };

  const toKey = (date) =>
    [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, '0'),
      String(date.getDate()).padStart(2, '0'),
    ].join('-');

  let popupConfirmed = false;
  let userSelectedDate = false;

  function submitFormWithProperties() {
    hiddenDate.value = dateInput.value;
    hiddenTime.value = timeSelect.value;

    document.querySelector('[name="properties[Fecha de entrega]"]').value =
      dateInput.value;
    document.querySelector('[name="properties[Horario de entrega]"]').value =
      timeSelect.value;

    productForm.dispatchEvent(new Event('submit'));

    const properties = {};

    document.querySelectorAll('[name^="properties["]').forEach(input => {
      const match = input.name.match(/^properties\[(.*?)\]$/);
      if (match) {
        const key = match[1];
        const value = input.value.trim();
        if (value) properties[key] = value;
      }
    });

    localStorage.setItem('propertiesData', JSON.stringify(properties));

    if(document.querySelector("#Dedicatoria:checked")) {
      localStorage.setItem('dedicatoria', "true");
    };

    if(document.querySelector("#Firma:checked")) {
      localStorage.setItem('firma', "true");
    }
  }

  function initializeDatePicker() {
    const today = new Date();
    const minDate = new Date(today);
    const localToday = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    const maxDate = new Date(today);
    minDate.setDate(today.getDate());
    maxDate.setMonth(today.getMonth() + 6);

    const formatDate = (date) => {
      return [
        date.getFullYear(),
        String(date.getMonth() + 1).padStart(2, '0'),
        String(date.getDate()).padStart(2, '0'),
      ].join('-');
    };

    dateInput.min = formatDate(minDate);
    dateInput.max = formatDate(maxDate);

    if (!dateInput.value) {
      dateInput.value = formatDate(today);
    }

    function debounce(func, delay) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
      };
    }

    dateInput.addEventListener(
      'change',
      debounce(function () {
        userSelectedDate = true;
        const parts = this.value.split('-');
        let selectedDate = new Date(
          parseInt(parts[0]),
          parseInt(parts[1]) - 1,
          parseInt(parts[2])
        );

        if (!isValidDate(selectedDate)) {
          const today = new Date();
          const minDate = new Date(today);
          const maxDate = new Date(today);

          minDate.setDate(today.getDate());
          maxDate.setMonth(today.getMonth() + 6);

          showInfoMessage(
            `Fecha inválida. Selecciona una fecha entre ${formatDateLocal(
              minDate
            )} y ${formatDateLocal(maxDate)}`
          );
          setTimeout(function () {
            hideInfoMessage();
          }, 3000);

          const closestValidDate =
            selectedDate < minDate ? minDate : maxDate;
          this.value = formatDateLocal(closestValidDate);
          selectedDate = closestValidDate;
        }

        // ✅ Verificar días bloqueados
        if (!checkBlockedDate(selectedDate) && !checkSunday(selectedDate)) {
          updateTimeSlots(selectedDate);
        }
      }, 400)
    );

    const parts = dateInput.value.split('-');
    const initialDate = new Date(
      parseInt(parts[0]),
      parseInt(parts[1]) - 1,
      parseInt(parts[2])
    );
    updateTimeSlots(initialDate);
  }

  function updateTimeSlots(selectedDate) {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinutes = now.getMinutes();
    const currentTotalMinutes = currentHour * 60 + currentMinutes;

    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const selectedDay = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      selectedDate.getDate()
    );
    const isToday = today.getTime() === selectedDay.getTime();
    
    // ✅ Obtener la fecha en formato string para buscar horarios bloqueados
    const dateKey = toKey(selectedDay);

    // Resetear todos los horarios primero
    Array.from(timeSelect.options).forEach((opt) => {
      if (opt.value !== '') {
        opt.disabled = false;
        opt.text = opt.text.replace(' (No disponible)', '').replace(' (Agotado)', '');
      }
    });
    

    // Bloquear por hora actual si es hoy
    if (isToday) {
      if (currentTotalMinutes >= 11 * 60) {
        timeSelect.options[1].disabled = true;
        timeSelect.options[1].text += ' (No disponible)';
      }
      if (currentTotalMinutes >= 15.5 * 60) {
        timeSelect.options[2].disabled = true;
        timeSelect.options[2].text += ' (No disponible)';
      }
     // if (currentTotalMinutes >= 15 * 60) {
     //   timeSelect.options[3].disabled = true;
     //   timeSelect.options[3].text += ' (No disponible)';
     // }
    }

    // ✅✅ NUEVO: Bloquear horarios específicos por fecha
    if (BLOCKED_TIME_SLOTS[dateKey]) {
      const blockedSlots = BLOCKED_TIME_SLOTS[dateKey];
      blockedSlots.forEach(slotIndex => {
        if (timeSelect.options[slotIndex]) {
          timeSelect.options[slotIndex].disabled = true;
          // Si ya no está bloqueado por hora, agregar texto "(Agotado)"
          if (!timeSelect.options[slotIndex].text.includes('(No disponible)')) {
            timeSelect.options[slotIndex].text += ' (Agotado)';
          }
        }
      });
    }

    // ✅ Bloquear domingos excepto los especiales
    if (selectedDay.getDay() === 0 && !SPECIAL_SUNDAYS.has(toKey(selectedDay))) {
      showInfoMessage('No hay entregas los domingos.');
      setTimeout(function () {
        hideInfoMessage();
      }, 3000);

      // deshabilita horarios
      Array.from(timeSelect.options).slice(1).forEach((opt) => {
        opt.disabled = true;
      });

      // mueve al siguiente día
      const nextDay = new Date(selectedDay);
      nextDay.setDate(selectedDay.getDate() + 1);
      dateInput.value = formatDateLocal(nextDay);
      updateTimeSlots(nextDay);
    }

    timeSelect.selectedIndex = 0;
  }

  // ✅ Verificar días bloqueados
  function checkBlockedDate(date) {
    const selectedDay = new Date(date);
    selectedDay.setHours(0, 0, 0, 0);
    
    if (BLOCKED_DATES.has(toKey(selectedDay))) {
      showInfoMessage('No hay entregas en esta fecha (día festivo).');
      setTimeout(function () {
        hideInfoMessage();
      }, 3000);

      const nextDay = new Date(selectedDay);
      nextDay.setDate(selectedDay.getDate() + 1);
      dateInput.value = formatDateLocal(nextDay);
      updateTimeSlots(nextDay);
      return true;
    }
    return false;
  }

  function checkSunday(date) {
    const selectedDay = new Date(date);
    selectedDay.setHours(0, 0, 0, 0);
    if (selectedDay.getDay() === 0 && !SPECIAL_SUNDAYS.has(toKey(selectedDay))) {
      showInfoMessage('No hay entregas los domingos.');
      setTimeout(function () {
        hideInfoMessage();
      }, 3000);

      const nextDay = new Date(selectedDay);
      nextDay.setDate(selectedDay.getDate() + 1);
      dateInput.value = formatDateLocal(nextDay);
      updateTimeSlots(nextDay);
      return true;
    }
    return false;
  }

  function formatDateLocal(date) {
    return [
      date.getFullYear(),
      String(date.getMonth() + 1).padStart(2, '0'),
      String(date.getDate()).padStart(2, '0'),
    ].join('-');
  }

  function isValidDate(selectedDate) {
    const today = new Date();
    const minDate = new Date(today);
    const maxDate = new Date(today);

    minDate.setDate(today.getDate());
    maxDate.setMonth(today.getMonth() + 6);

    const normalizedSelected = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      selectedDate.getDate()
    );

    const normalizedMin = new Date(
      minDate.getFullYear(),
      minDate.getMonth(),
      minDate.getDate()
    );

    const normalizedMax = new Date(
      maxDate.getFullYear(),
      maxDate.getMonth(),
      maxDate.getDate()
    );

    return normalizedSelected >= normalizedMin && normalizedSelected <= normalizedMax;
  }

  function showInfoMessage(message) {
    infoMessageEl.textContent = message;
    infoMessageEl.classList.remove('hidden');
  }

  function hideInfoMessage() {
    infoMessageEl.textContent = '';
    infoMessageEl.classList.add('hidden');
  }

  // ✅ NUEVO: mensajes de info dentro del popup de regalos
  function showGiftInfoMessage(message) {
    if (!giftInfoMessageEl) return;
    giftInfoMessageEl.textContent = message;
    giftInfoMessageEl.classList.remove('hidden');
  }

  function hideGiftInfoMessage() {
    if (!giftInfoMessageEl) return;
    giftInfoMessageEl.textContent = '';
    giftInfoMessageEl.classList.add('hidden');
  }

  // ✅ NUEVO: agrega al carrito (vía API nativa de Shopify) los productos
  // regalo seleccionados. Se hace ANTES de enviar el formulario del producto
  // principal, así el carrito lateral que ya se abre automáticamente
  // muestra ambos (producto principal + regalos) sin tocar esa lógica.
  async function addGiftsToCart(variantIds) {
    if (!variantIds.length) return;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: variantIds.map((id) => ({ id, quantity: 1 })),
        }),
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        console.error('Error al agregar regalos al carrito:', data);
        showGiftInfoMessage(
          'No se pudieron agregar uno o más regalos (puede que no haya stock). Continuaremos con tu pedido.'
        );
        setTimeout(hideGiftInfoMessage, 4000);
      }
    } catch (err) {
      console.error('Error de red al agregar regalos al carrito:', err);
      showGiftInfoMessage(
        'No se pudieron agregar los regalos por un error de conexión. Continuaremos con tu pedido.'
      );
      setTimeout(hideGiftInfoMessage, 4000);
    }
  }

  // ✅ NUEVO: Datos de los productos regalo (carrusel, descripción, etc.)
  // Vienen embebidos desde Liquid en un <script type="application/json">.
  let giftProductsData = [];
  try {
    const rawData = document.getElementById('gift-products-data')?.textContent;
    giftProductsData = rawData ? JSON.parse(rawData) : [];
  } catch (err) {
    console.error('Error al parsear los datos de productos regalo:', err);
  }

  let quickviewCurrentProduct = null;
  let quickviewCurrentImageIndex = 0;

  // ✅ NUEVO: pinta la imagen actual del carrusel + el estado de los puntos/flechas
  function renderQuickviewImage() {
    if (!quickviewCurrentProduct) return;
    const images = quickviewCurrentProduct.images || [];

    if (images.length === 0) {
      quickviewImageEl.removeAttribute('src');
      quickviewImageEl.alt = '';
    } else {
      quickviewImageEl.src = images[quickviewCurrentImageIndex];
      quickviewImageEl.alt = quickviewCurrentProduct.title || '';
    }

    const showNav = images.length > 1;
    if (quickviewPrevBtn) quickviewPrevBtn.style.display = showNav ? '' : 'none';
    if (quickviewNextBtn) quickviewNextBtn.style.display = showNav ? '' : 'none';

    if (quickviewDotsEl) {
      quickviewDotsEl.innerHTML = '';
      if (showNav) {
        images.forEach((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className =
            'gift-quickview-dot' + (index === quickviewCurrentImageIndex ? ' is-active' : '');
          dot.setAttribute('aria-label', `Ver imagen ${index + 1}`);
          dot.addEventListener('click', () => {
            quickviewCurrentImageIndex = index;
            renderQuickviewImage();
          });
          quickviewDotsEl.appendChild(dot);
        });
      }
    }
  }

  // ✅ NUEVO: abre el popup de vista rápida con los datos del producto elegido
  function openGiftQuickview(index) {
    const product = giftProductsData[index];
    if (!product || !giftQuickviewPopup) return;

    quickviewCurrentProduct = product;
    quickviewCurrentImageIndex = 0;

    quickviewTitleEl.textContent = product.title || '';
    quickviewPriceEl.textContent = product.price || '';
    quickviewDescriptionEl.textContent = product.miniDescription || '';

    if (quickviewAddBtn) {
      quickviewAddBtn.disabled = !product.available;
      quickviewAddBtn.textContent = product.available
        ? 'Agregar al carrito'
        : 'Agotado';
    }

    renderQuickviewImage();
    giftQuickviewPopup.classList.remove('hidden');
  }

  giftQuickviewTriggers.forEach((trigger) => {
    trigger.addEventListener('click', function (e) {
      // Evita que el clic suba hasta el <label> y desmarque/marque el checkbox del regalo
      e.stopPropagation();
      e.preventDefault();
      const index = parseInt(this.dataset.giftIndex, 10);
      openGiftQuickview(index);
    });
  });

  quickviewPrevBtn?.addEventListener('click', () => {
    if (!quickviewCurrentProduct) return;
    const images = quickviewCurrentProduct.images || [];
    if (images.length < 2) return;
    quickviewCurrentImageIndex =
      (quickviewCurrentImageIndex - 1 + images.length) % images.length;
    renderQuickviewImage();
  });

  quickviewNextBtn?.addEventListener('click', () => {
    if (!quickviewCurrentProduct) return;
    const images = quickviewCurrentProduct.images || [];
    if (images.length < 2) return;
    quickviewCurrentImageIndex = (quickviewCurrentImageIndex + 1) % images.length;
    renderQuickviewImage();
  });

  // ✅ NUEVO: "Agregar al carrito" en la vista rápida solo marca el checkbox
  // correspondiente en la lista de regalos; el agregado real ocurre al
  // presionar "Confirmar" en el popup de regalos, junto con todo lo demás.
  quickviewAddBtn?.addEventListener('click', () => {
    if (!quickviewCurrentProduct) return;

    const matchingCheckbox = Array.from(giftCheckboxes).find(
      (checkbox) => checkbox.value === String(quickviewCurrentProduct.variantId)
    );

    if (matchingCheckbox) {
      matchingCheckbox.checked = true;
    }

    giftQuickviewPopup.classList.add('hidden');

    showGiftInfoMessage(`"${quickviewCurrentProduct.title}" se agregó a tu selección.`);
    setTimeout(hideGiftInfoMessage, 2500);
  });

  closeGiftQuickviewBtn?.addEventListener('click', () => {
    giftQuickviewPopup.classList.add('hidden');
  });

  // ✅ Cambiar parseo de fecha para evitar problemas de huso
  dateInput.addEventListener('change', function () {
    userSelectedDate = true;
    const [y, m, d] = this.value.split('-').map(Number);
    const selectedDate = new Date(y, m - 1, d);
    // ✅ Verificar primero días bloqueados, luego domingos
    if (!checkBlockedDate(selectedDate) && !checkSunday(selectedDate)) {
      updateTimeSlots(selectedDate);
    }
  });

  closeBtn?.addEventListener('click', () => {
    popup.classList.add('hidden');
  });

  closeReceiverPopupBtn?.addEventListener('click', () => {
    receiverPopup.classList.add('hidden');
  });

  closeGiftPopupBtn?.addEventListener('click', () => {
    giftPopup.classList.add('hidden');
  });

  window.addEventListener('click', (event) => {
    if (event.target === popup) {
      popup.classList.add('hidden');
    }
    if (event.target === receiverPopup) {
      receiverPopup.classList.add('hidden');
    }
    if (event.target === giftPopup) {
      giftPopup.classList.add('hidden');
    }
    if (event.target === giftQuickviewPopup) {
      giftQuickviewPopup.classList.add('hidden');
    }
  });

  confirmBtn?.addEventListener('click', function () {
    if (dateInput.value && timeSelect.value && timeSelect.value !== '') {
      hiddenDate.value = dateInput.value;
      hiddenTime.value = timeSelect.value;
      popup.classList.add('hidden');
      receiverPopup.classList.remove('hidden');
    } else {
      showInfoMessage('Por favor selecciona una fecha y horario válidos.');
      setTimeout(function () {
        hideInfoMessage();
      }, 3000);
    }
  });

  confirmRecieverBtn?.addEventListener('click', function () {
    if (!Array.from(receiverFields).every((input) => input.value.trim() !== '')) {
      return;
    }

    receiverPopup.classList.add('hidden');

    // ✅ Si existe el popup de regalos (hay productos con el tag configurado),
    // se muestra antes de cerrar el flujo. Si no existe, se procede igual que antes.
    if (giftPopup) {
      giftPopup.classList.remove('hidden');
    } else {
      popupConfirmed = true;
      submitFormWithProperties();
    }
  });

  // ✅ NUEVO: confirmación del popup de regalos.
  // Si no se selecciona ningún regalo, solo se agrega el producto principal.
  // Si se selecciona uno o más, se agregan al carrito junto con el principal.
  confirmGiftsBtn?.addEventListener('click', async function () {
    const selectedVariantIds = Array.from(giftCheckboxes)
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => parseInt(checkbox.value, 10));

    confirmGiftsBtn.disabled = true;

    await addGiftsToCart(selectedVariantIds);

    confirmGiftsBtn.disabled = false;
    giftPopup.classList.add('hidden');

    popupConfirmed = true;
    submitFormWithProperties();
  });

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function (e) {
      if (!popupConfirmed) {
        e.preventDefault();
        e.stopPropagation();

        popup.classList.remove('hidden');
        initializeDatePicker();
      }
    });
  }

  if (popup && !popup.classList.contains('hidden')) {
    initializeDatePicker();
  }

  checkboxFieldEls.forEach((el) => {
    el.addEventListener('change', function () {
      const field = this.closest('.field__grid')?.querySelector('[js-field]');

      field.value = '';
      if (this.checked) {
        field.setAttribute('readonly', '');
      } else {
        field.removeAttribute('readonly');
      }
    });
  });
});


function loadPropertiesFromLocalStorage() {
  const storedData = localStorage.getItem('propertiesData');
  if (!storedData) return;

  const properties = JSON.parse(storedData);
  Object.entries(properties).forEach(([key, value]) => {
    const el = document.querySelector(`[name="properties[${key}]"]`);
    if (el) el.value = value;

    if(key === "Fecha de entrega") {
      document.querySelector("#delivery-date").value = value
    };

    if(key === "Horario de entrega") {
      document.querySelector("#delivery-time").value = value
    }
  });

  if(localStorage.getItem("dedicatoria") === "true") {
    const dedicatoria = document.querySelector("#Dedicatoria");
    dedicatoria.checked = true;
    setTimeout(function() {
      dedicatoria.dispatchEvent(new Event("change"));
    }, 200)
  };

  if(localStorage.getItem("firma") === "true") {
    const firma = document.querySelector("#Firma");
    firma.checked = true;
    setTimeout(function() {
      firma.dispatchEvent(new Event("change"));
    }, 200)
  }
}

loadPropertiesFromLocalStorage();